export default "__VITE_ASSET__450510f8__"